import { api } from "./client";
import type { Patient, PaginatedResponse } from "./types";

export interface PatientFilters {
  search?: string;
  status?: "ACTIVE" | "INACTIVE" | "BLOCKED";
  page?: number;
  limit?: number;
}

export interface CreatePatientData {
  name: string;
  email?: string;
  phone?: string;
  cpf?: string;
  birthDate?: string;
  gender?: "MALE" | "FEMALE" | "OTHER" | "PREFER_NOT_TO_SAY";
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  notes?: string;
  allergies?: string;
  medications?: string;
}

export const patientsService = {
  async list(filters?: PatientFilters): Promise<PaginatedResponse<Patient>> {
    return api.get<PaginatedResponse<Patient>>("/patients", filters);
  },

  async getById(id: string): Promise<Patient> {
    return api.get<Patient>(`/patients/${id}`);
  },

  async create(data: CreatePatientData): Promise<Patient> {
    return api.post<Patient>("/patients", data);
  },

  async update(id: string, data: Partial<CreatePatientData>): Promise<Patient> {
    return api.put<Patient>(`/patients/${id}`, data);
  },

  async delete(id: string): Promise<void> {
    return api.delete(`/patients/${id}`);
  },
};
